import { render, staticRenderFns } from "./DragPeopleOld.vue?vue&type=template&id=619e3a0c&"
import script from "./DragPeopleOld.vue?vue&type=script&lang=js&"
export * from "./DragPeopleOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports